export const uk = {
    'add-minus-word': 'Добавить в минус-фразы'
};
